import { render, staticRenderFns } from "./ProductCardPageRight.vue?vue&type=template&id=43125bd8&"
import script from "./ProductCardPageRight.vue?vue&type=script&lang=js&"
export * from "./ProductCardPageRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports